import { render, staticRenderFns } from "./wl.vue?vue&type=template&id=0a3156e8&scoped=true&"
import script from "./wl.vue?vue&type=script&lang=js&"
export * from "./wl.vue?vue&type=script&lang=js&"
import style0 from "./wl.vue?vue&type=style&index=0&id=0a3156e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3156e8",
  null
  
)

export default component.exports